import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedCoinwebWallet } from '@/networks/coinweb';

const HeaderWalletDrawerCwebWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedCoinwebWallet {...props} />;
};

export default HeaderWalletDrawerCwebWalletConnect;
